/**
 * Scope for block/region mutations.
 * @typedef {{ type: 'case', caseId: string, doc: object, setDoc: Function }} CaseScope
 * @typedef {{ type: 'protocol', protocolId: string }} ProtocolScope
 * @typedef {CaseScope | ProtocolScope} BlockScope
 */

export function isCaseScope(scope) {
    return scope?.type === 'case';
}

export function isProtocolScope(scope) {
    return scope?.type === 'protocol';
}

export function caseContextFromScope(scope) {
    if (!isCaseScope(scope)) return null;
    return {
        doc: scope.doc,
        setDoc: scope.setDoc,
        caseId: scope.caseId,
    };
}
